import { LinkButton, RegularButton } from "@components/button"
import { FlexBox } from "@components/wrapper"
import { TokenData } from "@interfaces/auth"
import dynamic from "next/dynamic"
import { AboutPopover, CorporatePopover, ServiceDropdown } from "./popover"

// Only logged-in visitors see it; keeps popper.js off the initial bundle.
const AccountPopover = dynamic(() =>
  import("./popover/AccountPopover").then((m) => m.AccountPopover)
)

export interface HeaderComponentProps {
  loginModalHandler: () => void
  isLogin?: boolean | number
  tokenData?: TokenData
  transparent?: boolean
}

export const LinkHead = ({ children, link }: { children: string; link: string }) => {
  return (
    <a
      href={link}
      className="hover:underline underline-offset-8 hover:font-semibold line-clamp-1 hover:text-blue"
      title={children}
    >
      {children}
    </a>
  )
}

export const HeaderComponent = ({
  loginModalHandler,
  isLogin,
  tokenData,
  transparent,
}: HeaderComponentProps) => {
  return (
    <nav className="flex items-center">
      <FlexBox align="center" justify="between" className="gap-10">
        <FlexBox align="center" className="gap-6">
          <ServiceDropdown transparent={transparent} />
          {/* <VideoPopover /> */}
          <CorporatePopover transparent={transparent} />
          <AboutPopover transparent={transparent} />
          {/* <a href="/prakerja" className="flex gap-2 font-medium">
            <Image
              src={`${HARISENIN_PUBLIC_LOGO}/logo_kartu-prakerja.png`}
              width={100}
              height={25}
              className="h-[25px] w-auto"
            />
          </a> */}
        </FlexBox>

        {isLogin ? (
          <AccountPopover userData={tokenData as TokenData} />
        ) : (
          <FlexBox justify="between" align="center" className="gap-4">
            <LinkButton
              href="/register"
              variant="outline-blue"
              id="btn-regist"
              rounded
              customPadding="px-4 py-3"
            >
              Daftar
            </LinkButton>
            <RegularButton
              variant="solid-blue"
              onClick={loginModalHandler}
              id="btn-login"
              rounded
              customPadding="px-4 py-3"
            >
              Masuk
            </RegularButton>
          </FlexBox>
        )}
      </FlexBox>
    </nav>
  )
}
